import request from '@/config/axios'

export const initOrgData = (data) => {
  return request.post({
    baseUrl: 'api-m2i',
    url: '/m2i/system/org/initialize',
    data: data
  })
}

export const GetGeneralSettings = (params) => {
  return request.get({
    baseUrl: 'api-m2i',
    url: '/m2i/system/general/setting',
    params: params
  })
}

export const SetGeneralSettings = (data) => {
  return request.post({
    baseUrl: 'api-m2i',
    url: '/m2i/system/general/setting',
    data: data
  })
}

export const GetLang = (params) => {
  return request.get({
    baseUrl: 'api-m2i',
    url: '/m2i/i18n-data',
    params: params,
    timeout: 5000
  })
}

export const RegisterLang = (data) => {
  return request.post({
    baseUrl: 'api-m2i',
    url: '/m2i/i18n-data',
    data: data
  })
}

export const GetNotifyAudio = (params) => {
  return request.get({
    baseUrl: 'api-m2i',
    url: '/m2i/system/alertsound',
    params: params,
    timeout: 5000
  })
}

export const SetNotifyAudio = (data) => {
  return request.post({
    baseUrl: 'api-m2i',
    url: '/m2i/system/alertsound',
    data: data
  })
}

export const GetDevPos = (params) => {
  return request.get({
    baseUrl: 'api-m2i',
    url: '/m2i/area/monitor/devpos/ids',
    params: params
  })
}